export default __webpack_public_path__ + "static/media/product-04 (1).6172d3bd.jpg";